import {getReviewMetrics} from '../services/reviews';

export const actions = {
  FETCH_PENDING: 'REVIEW_METRICS::FETCH_PENDING',
  FETCH_FULFILLED: 'REVIEW_METRICS::FETCH_FULFILLED',
  FETCH_REJECTED: 'REVIEW_METRICS::FETCH_REJECTED',
};

export function fetchReviewMetrics({organizationId, serviceHandle}) {
  return dispatch => {
    dispatch({type: actions.FETCH_PENDING});

    return getReviewMetrics({organizationId, serviceHandle})
      .then(data => {
        dispatch({type: actions.FETCH_FULFILLED, payload: {data}});
        return data;
      })
      .catch(err => {
        dispatch({
          type: actions.FETCH_REJECTED,
          payload: {
            error: {
              title: 'Unable to fetch review metrics',
              message: err.message,
            },
          },
        });
      });
  };
}
